// DocDownload.js
import { useState, useEffect } from "react";
import axios from "axios";
import { Alert, Row, Col, Button } from "react-bootstrap";
import ReactLoading from "react-loading";
import { useHistory, useParams } from "react-router-dom";
import PdfViewer from "./PdfViewer";  // Adjust the import path if needed
import Config from "../../config";

const DocDownload = () => {
    const params = useParams();
    const history = useHistory();
    const [showAlert, setAlertShow] = useState(false);
    const [message, setMessage] = useState("");
    const [alertType, setAlertType] = useState("danger");
    const [buttonStatus, setButtonStatus] = useState(false);
    const [previewBlob, setPreviewBlob] = useState(null); // For react-pdf preview
    const [downloadFilename, setDownloadFilename] = useState(null);
    const data = JSON.parse(localStorage.getItem("jwtToken"));

    const getFile = async () => {
        setButtonStatus(true);
        let token = data?.token || "";

        try {
            // Get file metadata
            const metadataRes = await axios.get(
                `${Config.BASE_URL}/api/user/docs_url/file_data/${params.file_id}`,
                { headers: { authorization: `Bearer ${token}` } }
            );
            const fileData = metadataRes.data.fileData;
            const filename = fileData.title + "." + fileData.file_type;

            // Check subscription status
            if (metadataRes.data.is_subscribed && metadataRes.data.is_subscribed === "canceled") {
                history.push("/subscription/canceled");
                return;
            }

            // Download the file as a blob
            const downloadRes = await axios({
                url: `${Config.BASE_URL}/api/user/docs_url/download/${params.file_id}`,
                method: "GET",
                responseType: "blob",
                headers: { authorization: `Bearer ${token}` },
            });

            if (fileData.show_preview) {
                // Create a PDF blob for preview and update state
                const pdfBlob = new Blob([downloadRes.data], { type: "application/pdf" });
                setPreviewBlob(pdfBlob);
                setDownloadFilename(filename);
                setButtonStatus(false);
                // setAlertType("success");
                // setAlertShow(true);
                // setMessage("PDF preview loaded");
            } else {
                // Trigger a file download
                const pdfBlob = new Blob([downloadRes.data], { type: "application/pdf" });
                const url = window.URL.createObjectURL(pdfBlob);
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", filename);
                document.body.appendChild(link);
                link.click();

                setButtonStatus(false);
                setAlertType("success");
                setAlertShow(true);
                setMessage("File has been downloaded");
            }
        } catch (error) {
            console.error("Error:", error);
            setButtonStatus(false);
            setAlertType("danger");
            setAlertShow(true);
            setMessage("An error occurred while processing your request.");
        }
    };

    const handleDownloadPreview = () => {
        if (!previewBlob) return;
        const url = window.URL.createObjectURL(previewBlob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", downloadFilename || "file.pdf");
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
    };

    useEffect(() => {
        getFile();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            {buttonStatus && <ReactLoading type="spokes" color="#1c56ac" className="loader" />}
            <Row>
                <Col>
                    <Alert variant={alertType} show={showAlert} onClose={() => setAlertShow(false)} dismissible>
                        <p>{message}</p>
                    </Alert>
                </Col>
            </Row>
            {/* Display the PDF preview if available */}
            {previewBlob && (
                <>
                    <Row style={{ margin: '10px 0' }}>
                        <Col>
                            <Button variant="primary" onClick={handleDownloadPreview} disabled={buttonStatus}>
                                Download
                            </Button>
                        </Col>
                    </Row>
                    <Row style={{ height: "100vh", margin: 0 }}>
                        <Col style={{ padding: 0 }}>
                            <PdfViewer pdfBlob={previewBlob} />
                        </Col>
                    </Row>
                </>
            )}
        </>
    );
};

export default DocDownload;
